import { render, staticRenderFns } from "./ScreeningProcessEditRule.vue?vue&type=template&id=1cc59090&scoped=true&"
import script from "./ScreeningProcessEditRule.vue?vue&type=script&lang=js&"
export * from "./ScreeningProcessEditRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc59090",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
